import {Component, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {StorageService} from './services/storage/storage.service';
import {Title} from '@angular/platform-browser';
import {instances} from './properties';
import {environment} from '../environments/environment';
import {PrimeNGConfig} from 'primeng/api';
import {AuthenticationService} from './services/apiServices/security/authentication.service';


/**
 * The main entry for the application using router-outlet
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  /**
   *
   * @param {TranslateService} translateService - translate service
   * @param {TranslateService} translateService - storage service
   * @param storage
   * @param titleService
   * @param aut
   * @param primeNGConfig
   * @param {TranslateService} translateService - title service
   */
  constructor(private translateService: TranslateService, private storage: StorageService,
              private titleService: Title, private authenticationService: AuthenticationService, private primeNGConfig: PrimeNGConfig) {
    // fallback Language
    let dl: string;
    if (this.storage.getLangFromStorage()) {
      dl = this.storage.getLangFromStorage();
    } else {
      dl = translateService.getBrowserLang();
    }
    this.translateService.get('primeng').subscribe(res =>  {
      this.updatePrimeNgTranslations(res);
    });
    authenticationService.changeLang(dl);
    this.translateService.onLangChange.subscribe(() => {
      this.translateService.get('primeng').subscribe(res =>  {
        this.updatePrimeNgTranslations(res);
      });
    });
    this.setTitle(instances[environment.instance].title);
  }
  updatePrimeNgTranslations(res) {
    this.primeNGConfig.setTranslation(res);
  }
  public  preventDefaultDragOver( event ) {
    event.preventDefault();
    event.stopPropagation();
  }
  public  preventDefaultDrop( event ) {
    event.preventDefault();
    event.stopPropagation();
  }

  public setTitle( newTitle: string) {
    this.titleService.setTitle( newTitle );
  }
}
